import { isAccountAllowed } from '$lib/components/permission/permission'
import {
	type AuthenticationV1Account,
	EnumsV1Permission,
	type SettingsV1TenantSettings,
} from '@sdk/Api'
import type { User } from 'firebase/auth'

export function initIntercomAdminLoggedIn(
	fbUser: User,
	tenantId: string,
	locale: string,
	settings: SettingsV1TenantSettings,
) {
	if (window?.['Intercom']) {
		window['Intercom']?.('boot', {
			api_base: 'https://api-iam.intercom.io',
			app_id: 'sut07euy',
			name: fbUser.displayName,
			email: fbUser.email,
			created_at: Number(fbUser.metadata.creationTime),
			tenant_id: tenantId,
			tenant_type: settings.tenantType,
			language_override: locale,
			membership_plan_id: settings.membershipPlanId,
			membership_platform_id: settings.membershipPlatformId,
			free_trial_active: settings.freeTrialActive,
			hide_default_launcher: false,
		})
	}
}

export function updateIntercomVisibility($account: AuthenticationV1Account) {
	if (window?.['Intercom']) {
		window['Intercom']?.('update', {
			hide_default_launcher: !isAccountAllowed(
				EnumsV1Permission.PERMISSION_VIEW_INTERCOM,
				$account,
			),
		})
	}
}

export function updateIntercomFreeTrial(freeTrialActive: boolean) {
	if (window?.['Intercom']) {
		window['Intercom']?.('update', {
			free_trial_active: freeTrialActive,
		})
	}
}
